/* eslint no-param-reassign: 0 */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import Actions from '@redux/reports';
import ReportsTable from './reportsTable';
import { officerOverviewJobColumns, officerOverviewLocationColumns } from '../utils/columnsDefinition';

class OfficerOverviewReport extends Component {
	shouldComponentUpdate = ({ reportData, filterPrintData }) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.reportData, reportData)
			|| !isEqual(lastProps.filterPrintData, filterPrintData)
		);
	}

	componentWillUnmount = () => {
		const { resetReportsListData } = this.props;
		resetReportsListData();
	}

	showFilterDataForPrint = (filterPrintData) => (
		<Fragment>
			<div className="margin-top-10">
				<span className="color-dark font-regular report-table-header-title">Filters</span>
			</div>
			<Choose>
				<When condition={filterPrintData.length}>
					<For
						each="item"
						of={filterPrintData}
					>
						<div
							key={item.label}
							className="flex"
						>
							<span className="font-light color-gray-bayoux flex-1">{ item.label }</span>
							<span className="font-regular color-gray-bayoux flex-2">
								:
								{ item.value }
							</span>
						</div>
					</For>
				</When>
				<Otherwise>
					<span>No filter Applied</span>
				</Otherwise>
			</Choose>
		</Fragment>
	);

	render() {
		const { reportData, filterPrintData, TimeZoneId } = this.props;
		return (
			<Fragment>
				<h3 className="font-size-24 font-regular color-gray-oxford">Officer Overview Report</h3>
				<div className="show-print">
					{ this.showFilterDataForPrint(filterPrintData) }
				</div>
				<ReportsTable
					header="Jobs"
					data={reportData.JobOverviewList || []}
					tableColumn={officerOverviewJobColumns(TimeZoneId)}
				/>
				<ReportsTable
					header="Locations"
					data={reportData.LocationJobOverviewList || []}
					tableColumn={officerOverviewLocationColumns('Location')}
				/>
			</Fragment>
		);
	}
}

const mapStateToProps = ({
	reports : {
		reportData,
		filterPrintData,
	}, app: { user: { TimeZoneId } },
}) => ({
	reportData,
	filterPrintData,
	TimeZoneId,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	resetReportsListData : bindActionCreators(Actions, dispatch).resetReportsListData,

});

OfficerOverviewReport.propTypes = {
	TimeZoneId           : PropTypes.string,
	filterPrintData      : PropTypes.array,
	reportData           : PropTypes.object,
	resetReportsListData : PropTypes.func.isRequired,
};

OfficerOverviewReport.defaultProps = {
	TimeZoneId      : '',
	filterPrintData : [],
	reportData      : {},
};

export default connect(mapStateToProps, mapDispatchToProps)(OfficerOverviewReport);
